import { createSimpleFunctional } from '@/util'

export default createSimpleFunctional('v-list-item-subtitle')
